module.exports = __webpack_public_path__ + "img/drug-icon.bf11f977.png";